import { validateReferrer } from "@shared/common/utils/user-form-validation";
import { Form, FormItemProps, Select, SelectProps } from "antd";

interface IFormItemInputReferrerProps extends FormItemProps {
  select?: SelectProps;
}

const FormItemInputReferrer = ({
  select,
  label,
  className,
  ...props
}: IFormItemInputReferrerProps) => {
  return (
    <Form.Item
      name="referrer"
      label={label}
      rules={[
        {
          async validator(_rule, value) {
            validateReferrer(value);
          },
        },
      ]}
      {...props}
      validateTrigger="onSubmit"
      className={className}
    >
      <Select
        placeholder="유입 경로를 선택해 주세요."
        options={[
          { value: "광고", label: "광고" },
          { value: "검색", label: "검색" },
          { value: "지인 소개", label: "지인 소개" },
          { value: "블로그", label: "블로그" },
          { value: "SNS", label: "SNS" },
          { value: "유튜브", label: "유튜브" },
          { value: "기타", label: "기타" },
        ]}
        {...select}
        className={select?.className}
      />
    </Form.Item>
  );
};

export default FormItemInputReferrer;
